import { Wall } from '../domain';
import { wallLength } from './wall-controllers';

export const findRoomCenter = (walls: Wall[]) => {
    if(walls.length == 0) return [0, 0];

    const first = walls[0];

    let
        r = wallLength(first),
        x = first.position.x + r*Math.cos(first.rotation.y),
        z = first.position.z + r*Math.sin(-first.rotation.y),
        minX = Math.min(first.position.x, x),
        maxX = Math.max(first.position.x, x),
        minZ = Math.min(first.position.z, z),
        maxZ = Math.max(first.position.z, z);

    for(const wall of walls.slice(1)) {
        r = wallLength(wall),
        x = wall.position.x + r*Math.cos(wall.rotation.y),
        z = wall.position.z + r*Math.sin(-wall.rotation.y);
        minX = Math.min(minX, wall.position.x, x);
        minZ = Math.min(minZ, wall.position.z, z);
        maxX = Math.max(maxX, wall.position.x, x);
        maxZ = Math.max(maxZ, wall.position.z, z);
    }

    const
        width = maxX - minX,
        depth = maxZ - minZ;
    return [minX + width / 2, maxZ - depth / 2];
}
